export default {
    validationTypes: {
        required: (type, value) => !value,
        pattern: (type, value) => type && !type.test(value),
        maximumLength: (type, value) => type && type < String(value).length,
        minimumLength: (type, value) => type && type > String(value).length,
        maxValue: (type, value) => type && type < value,
        minValue: (type, value) => type && type > value,
    },
    //Placeholder for message replace {validationType}, {filedName}, {validationValue}
    //{validationType} ex: pattern, maximumLength ..
    // {filedName} ex: input name // company_name
    // {validationValue} ex: /^[a-zA-Z0-9]+$/, 10
    default: {
        message: "The value is not valid",
        pattern: {
            message: "Certain characters are not allowed",
        },
        maximumLength: {
            message: "Maximum length must be {value}",
        },
        minimumLength: {
            message: "Minimum length must be {value}",
        },
        required: {
            message: "This field is required",
        },
        maxValue: {
            message: "Maximum value must be {value}",
        },
        minValue: {
            message: "Minimum value must be {value}",
        },
    },
    text: {
        pattern: /^[a-zA-Z0-9_ !"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~৳]*$/,
        maximumLength: 255,
        minimumLength: 2,
    },
    bangla: {
        pattern:
            /^[০-৯\u0980-\u09FF\u0964_ !"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~৳]*$/,
        maximumLength: 255,
        minimumLength: 2,
    },
    name: {
        pattern: /^[a-zA-Z0-9_ !"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]*$/,
        maximumLength: 255,
        minimumLength: 2,
    },
    textarea: {
        pattern: /^[a-zA-Z0-9_!"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~\s]*$/,
        maximumLength: 255,
        minimumLength: 2,
    },
    number: {
        maximumLength: 9,
        minimumLength: 1,
        maxValue: 999999999,
        minValue: 0,
        pattern: {
            value: /^[0-9]+$/,
            message: "Only integer numbers are allowed",
        },
    },
    password: {
        pattern: /^[a-zA-Z0-9_ !"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]*$/,
        minimumLength: 6,
        maximumLength: 255,
    },
    decimal: {
        pattern: /^[0-9]+(\.[0-9]+)?$/,
        maximumLength: null,
        minimumLength: null,
        maxValue: 999999999.99,
        minValue: 0,
    },
    bd_phone: {
        pattern: {
            value: /^((01|8801|\+8801)\d{9})$/,
            message: "Invalid contact number",
        },
    },
    bd_phone_landline: {
        pattern: {
            value: /^((01|8801|\+8801)\d{9}|(096|88096|\+88096)\d{8})$/,
            message: "Invalid contact number",
        },
    },
    bd_in_phone: {
        pattern: {
            value: /^((01|8801|\+8801)\d{9}|(\+91|91|0)?[789]\d{9})$/,
            message: "Invalid contact number",
        },
    },
    bd_in_phone_landline: {
        pattern: {
            value: /^((01|8801|\+8801)\d{9}|(096|88096|\+88096)\d{8}|(\+91|91|0)?[789]\d{9})$/,
            message: "Invalid contact number",
        },
    },
    email: {
        pattern: {
            value: /^(?!.*\.\.)(?!.*--)[a-zA-Z0-9][a-zA-Z0-9._%+-]*[a-zA-Z0-9]@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,20}$/,
            message: "Invalid email provided",
        },
        maximumLength: 255,
    },
    subdomain: {
        pattern: {
            value: /^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*$/,
            message: "Invalid subdomain provided",
        },
        maximumLength: 255,
        minimumLength: 2,
    },
    domain: {
        pattern: {
            value: /^[a-zA-Z0-9-]+\.(?:[a-zA-Z]{2,20}\.)*[a-zA-Z]{2,20}$/,
            message: "Invalid domain provided",
        },
        maximumLength: 255,
        minimumLength: 2,
    },
    url: {
        pattern: {
            value: /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?$/,
            message: "Invalid URL provided",
        },
        maximumLength: 255,
        minimumLength: 2,
    },
    username: {
        pattern: {
            value: /^[a-zA-Z0-9_ !"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]+$/,
            message: "Invalid username provided",
        },
    },
    trip_number: {
        pattern: /^[a-zA-Z0-9_ !"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]*$/,
        maximumLength: 255,
        minimumLength: 2,
    },
    date: {
        pattern: {
            value: /^(\d{4})[\/-](0[1-9]|1[0-2])[\/-]([0-2][0-9]|3[01])$/,
            message: "Invalid date",
        },
    },
    "datetime-local": {
        pattern: {
            value: /^(\d{4})[\/-](0[1-9]|1[0-2])[\/-]([0-2][0-9]|3[01])T(?:[01][0-9]|2[0-3]):[0-5][0-9]$/,
            message: "Invalid date",
        },
    },
    time: {
        pattern: {
            value: /^(?:[01][0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/,
            message: "Invalid time",
        },
    },
    passport: {
        pattern: {
            value: /^[A-Z0-9]{6,9}$/,
            message: "Invalid passport number",
        },
    },
    nid: {
        pattern: {
            value: /^\d{10}|\d{13}|\d{17}$/,
            message:
                "Invalid nid number. It must be exactly 10 or 13 or 17 digits.",
        },
    },
    trade_licence: {
        pattern: {
            value: /^\d{10}|\d{13}|\d{17}|\d{6,12}$/,
            message:
                "Invalid trade licence number. It must be between 6 and 12 digits.",
        },
    },
    alphanum: {
        pattern: {
            value: /^[A-Za-z0-9]*$/,
            message: "Only alphanumeric characters are allowed",
        },
    },
    coupon: {
        pattern: {
            value: /^([A-Z0-9]{3,16}|[A-Z]{3,16}|\d{3,16})$/,
            message: "Invalid coupon code",
        },
        minimumLength: 3,
        maximumLength: 16,
    },
    year: {
        maximumLength: 4,
        minimumLength: 4,
        pattern: {
            value: /^[0-9]+$/,
            message: "Invalid year",
        },
    },
    company_call_center_phone: {
        pattern: {
            value: /^(?:((01|8801|\+8801)\d{9})|((096|88096|\+88096)\d{8})|(16\d{3}))$/,
            message: "Invalid contact number",
        },
    },

    positive_negative_number: {
        maximumLength: 9,
        minimumLength: 1,
        maxValue: 999999999,
        pattern: {
            value: /^-?[0-9]+$/,
            message: "Only integer numbers are allowed",
        },
    },
    name_with_bangla: {
        pattern:
            /^[\u0980-\u09FFa-zA-Z0-9_ !"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]*$/,
        maximumLength: 255,
        minimumLength: 2,
    },
    text_with_bangla: {
        pattern:
            /^[\u0980-\u09FFa-zA-Z0-9_ !"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~]*$/,
        maximumLength: 255,
        minimumLength: 2,
    },
    //add more rules in here
};
